// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueLazyload from 'vue-lazyload'
import _ from 'lodash';
import MintUI from 'mint-ui';
import Promise from 'promise-polyfill';
import PhotoSwipe from 'photoswipe/dist/photoswipe.js'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default.min.js'
import 'vxe-table/lib/style.css';
import 'mint-ui/lib/style.css'
import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/default-skin/default-skin.css'
import store from './storage/vuex'
import 'animate.css/animate.min.css'
import 'font-awesome/css/font-awesome.min.css'
import 'bootstrap/dist/css/bootstrap.css'
import '@/assets/css/common.css'
// import IScroll from 'iscroll/build/iscroll-infinite'
import disabledPassword from './directive/disabledPassword'
import './common/axiosSetting'
import './common/Helper'
import './common/systemSetting'
import Alert from './common/alert'
import kxSelect from '@/components/common/kxSelect'
import kxSelectPopper from '@/components/common/kxSelectPopper'
import bdDialog from '@/components/common/bdDialog'
import localStorage from './storage/localStorage'
import session from './storage/sessionStorage'
import './assets/images/favicon.ico'
import loadPic from './assets/images/load.gif'
import errPic from './assets/images/default_goods_portrait.jpg'
import FastClick from 'fastclick'
import psl from 'psl'
import '@/assets/js/checkAppUpdate' //检查app版本更新
import 'xe-utils';
import '@/common/vxeTableUse';
import CONSTANTS from '@/common/constants'
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
import versionCheck from '@/assets/js/versionCheck' // 引入版本检查服务



//低版本的ios使用FastClick  其他版本不使用
let userAgent= navigator.userAgent.toLowerCase();
if(userAgent.indexOf('ipad') > -1){
	let OSversion = /cpu os (.*) like mac os x/g.exec(userAgent);
	OSversion = OSversion[1];
	if(OSversion){
		OSversion = OSversion.replace('_','.');
		OSversion = isNaN(parseFloat(OSversion)) ? 0 : parseFloat(OSversion);
	}
	if(OSversion < 11){
		FastClick.attach(document.body, null);
	}
	// ipad版本小于9的提示
	if(OSversion < 9){
		MintUI.MessageBox({
			title : '温馨提示',
			message : '当前IOS版本过低，可能影响使用性能，建议使用IOS9.0以上版本',
			showCancelButton : false,
			confirmButtonClass : 'MintUI-alert-btn'
		});
	}
}
// android pad系统版本小于6的提示
if(userAgent.indexOf('android') > -1){
	let AndroidOSVersion = /linux; android (.*);/g.exec(userAgent);
	AndroidOSVersion = AndroidOSVersion[1] && parseInt(AndroidOSVersion[1]);
	if(AndroidOSVersion && !isNaN(AndroidOSVersion) && AndroidOSVersion < 6){
		MintUI.MessageBox({
			title : '温馨提示',
			message : '当前系统版本过低，可能影响使用性能，建议使用Android 6.0以上版本的设备',
			showCancelButton : false,
			confirmButtonClass : 'MintUI-alert-btn'
		});
	}
}
// import Vodal from 'vodal';
// import "vodal/common.css";
// import "vodal/rotate.css";
// Vue.component(Vodal.name, Vodal);

if (!window.Promise) {
	window.Promise = Promise;
}
/* eslint-disable */
Number.prototype.toFixedNew = function t(d) {
	/* eslint-disable */
	var s=this+"";
	if(!d)d=0;
	if(s.indexOf(".")==-1)s+=".";
	s+=new Array(d+1).join("0");
	if(new RegExp("^(-|\\+)?(\\d+(\\.\\d{0,"+(d+1)+"})?)\\d*$").test(s)){
		var s="0"+RegExp.$2,pm=RegExp.$1,a=RegExp.$3.length,b=true;
		if(a==d+2){
			a=s.match(/\d/g);
			if(parseInt(a[a.length-1])>4){
				for(var i=a.length-2;i>=0;i--){
					a[i]=parseInt(a[i])+1;
					if(a[i]==10){
						a[i]=0;
						b=i!=1;
					}else break;
				}
			}
			s=a.join("").replace(new RegExp("(\\d+)(\\d{"+d+"})\\d$"),"$1.$2");

		}if(b)s=s.substr(1);
		return (pm+s).replace(/\.$/,"");
	}
	return this+"";
  };
Vue.prototype._ = _;
Vue.prototype.constants = CONSTANTS;
Vue.prototype.$PhotoSwipe = (el,items,options)=>{
	return new PhotoSwipe(el,PhotoSwipeUI_Default,items,options);
}
// Vue.prototype.iscroll = (obj,options)=>{
// 	return new IScroll(obj,options);
// };
Vue.use(kxSelect);
Vue.use(kxSelectPopper);
Vue.use(bdDialog);
Vue.use(Alert);
Vue.use(MintUI);
Vue.use(disabledPassword);
Vue.use(session);
Vue.use(Viewer);
Vue.use(localStorage);
Vue.use(VueLazyload, {
	preLoad : 1.3,
	error : errPic,
	loading : loadPic,
	attempt : 1
});

Vue.config.productionTip = false;
Vue.config.devtools = true || process.env.NODE_ENV !== 'production';
if(process.env.NODE_ENV === 'production'){
	Vue.config.errorHandler = function (err, vm) {
		console.log(err, vm);
	}
}

window.eventBus = new Vue();
try{
	sessionStorage.setItem('isTraceless',1);
	sessionStorage.removeItem('isTraceless');
}catch(e){
	MintUI.Toast({
		message : '请关闭无痕模式',
		duration : 999999,
	});
}


if(navigator.userAgent.indexOf('iPad')>=0){
	document.body.className = document.body.className + ' cur';
}

/* eslint-disable no-new */
new Vue({
	el : '#app',
	router,
	store,
	template : '<App/>',
	components : { App },
	watch : {
		'$route' (to){
			/**
			 11=>'订货会订货端',
			 12=>'内审会前端',
			 20=>'品牌商后台管理',
			 21=>'品牌商后台订货会',
			 22=>'品牌商后台内审会',
			 30=>'app管理端',
			 31=>'app订货会',
			 32=>'app内审会'
			 */
			let appType = '11';
			let url = "https://www.bidinghuo.cn";
			let host = document.domain;
			let baseHost = psl.parse(host);
			if(baseHost.domain && process.env.PLATFORM !== 'testApp' && process.env.PLATFORM !== 'app'){
				url = '//www.' + baseHost.domain;
			}
			if(process.env.PLATFORM === 'testApp'){
				url = 'http://www.bdh.com';
			}
			try {
				if(process.env.NODE_ENV === 'production'&& process.env.PLATFORM !== 'testApp' && process.env.PLATFORM !== 'app') {
					this.$axios({
						url : url + '/api/log/add.json',
						method : 'post',
						data : {
							meeting_id : this.$getSessionStorageByName('meetingDetail') ? this.$getSessionStorageByName('meetingDetail').meeting_id : '',
							member_id : this.$getSessionStorageByName('userInfo') ? this.$getSessionStorageByName('userInfo').id : '',
							app_type : appType,
							url : document.location.href,
							vue_path : to.fullPath,
							title : to.meta.title,
							domain : document.domain,
							wap_role : this.$getSessionStorageByName('userInfo') ? this.$getSessionStorageByName('userInfo').wap_role : ''
						}
					}).catch((e)=>{
						console.log(e);
					});
				}
			}catch (e) {
				console.log(e)
			}
		}
	}
});


// 当前域名
function currentDomain() {
	let currentDomain = 'localhost';
	if (process.env.NODE_ENV === 'production' && location.host.includes('.')) {
		const curentHostArr = location.host.split('.');
		const targetIndex = curentHostArr.findIndex(item => item !== 'www');
		if (targetIndex !== -1) {
			currentDomain = curentHostArr[targetIndex];
		}
	}
	return currentDomain;
}
const bdhV2 = ['a', 'localhost', 'zh', 'test','test3'].includes(currentDomain());
// 在生产环境初始化版本检查服务
if (process.env.NODE_ENV === 'production' && bdhV2) {
	// 从package.json获取当前版本号
	versionCheck.init(process.env.VERSION || '');
	// 初始化构建ID为当前构建的ID，避免用户第一次加载就收到更新提示
	versionCheck.currentBuildId = process.env.BUILD_ID || '';
}



// WEBPACK FOOTER //
// ./src/main.js